import React, { useEffect, useState } from 'react'
import TutorSidebar from '../../TutorSidebar/TutorSidebar'
import TutorFooter from '../../TutorFooter/TutorFooter'
import { Link, useNavigate, useParams } from 'react-router-dom'
import TutorHeader from '../../TutorHeader/TutorHeader'
import { useDispatch, useSelector } from 'react-redux'
import { getTutorMyCourseBatchListData } from '../../../../Redux/action/TutorAction'
import Beatloader from '../../../../Common/BeatLoader'
import ResponsivePagination from '../../../../Common/Pagination'

const TutorCourseBatchList = () => {
    const dispatch = useDispatch();
    const { b64id } = useParams();
    const navigate = useNavigate();
    useEffect(() => {
        try {

            const courseId = atob(b64id);

            if (!courseId || isNaN(courseId)) {
                throw new Error("Invalid course ID");
            }

            dispatch(getTutorMyCourseBatchListData(courseId));
        } catch (error) {

            navigate(-1);
        }
    }, [b64id]);

    const {
        loadingTutorMyCourseGroupBatchListApi,
        TutorMyCourseGroupBatchListApiData,
        TutorMyCourseGroupBatchListApiError
    } = useSelector(state => state?.TutorReducer);

    //pagination


    const [currentData, setCurrentData] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1); // ✅ 1-based page index
    const dataPerPage = 10;

    useEffect(() => {
        if (!TutorMyCourseGroupBatchListApiData) return;

        const start = (currentPage - 1) * dataPerPage;
        const end = start + dataPerPage;

        setCurrentData(TutorMyCourseGroupBatchListApiData.slice(start, end));
        setPageCount(Math.ceil(TutorMyCourseGroupBatchListApiData.length / dataPerPage));
    }, [currentPage, dataPerPage, TutorMyCourseGroupBatchListApiData]);

    const handlePageClick = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo(0, 0);
    };

    return (
        <div className='pagination-component'>

            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;Group Course Batch List
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                <div className="course-list-sec">
                                    {loadingTutorMyCourseGroupBatchListApi ?
                                        <Beatloader />
                                        :
                                        <div className="row">
                                            {TutorMyCourseGroupBatchListApiData?.length > 0 ?
                                                currentData?.map((data) => (
                                                    <div className="col-lg-6 col-md-6 mb-4">
                                                        <div className="card bg-light">
                                                            <div className="card-body">
                                                                <div className="row">
                                                                    <div className="col-lg-6 col-md-6">
                                                                        <h6>Batch Name: {data?.batch_name}</h6>
                                                                    </div>
                                                                    {data?.batchesession?.map((item, index) => (
                                                                        <div className='mt-3 row'>
                                                                            <div className="col-lg-12 col-md-12">
                                                                                <h6>Batch Session: {index + 1}</h6>
                                                                            </div>
                                                                            <div className="col-lg-6 col-md-6">
                                                                                <h6>Max. Students: {item?.max_no_of_student}</h6>
                                                                            </div>
                                                                            <div className="col-lg-6 col-md-6">
                                                                                <h6>Enroll Students: {item?.current_enrollment}</h6>
                                                                            </div>
                                                                            <div className="row col-lg-12">
                                                                                <div className="col-lg-6 col-md-12 my-2">
                                                                                    <div className="session-box p-2 mt-3 border border-2 rounded" style={{ height: '100%' }}>
                                                                                        <p className="mb-1">Session Start Date</p>
                                                                                        <div className="d-flex justify-content-between align-items-center me-0">
                                                                                            {/* <div className="col-lg-10 col-md-10"> */}
                                                                                            <h6 className="mb-0">{item?.batch_start_date}</h6>
                                                                                            {/* </div> */}
                                                                                            {/* <div className="col-lg-2 col-md-2"> */}
                                                                                            <i className="fa-solid fa-calendar-days" />
                                                                                            {/* </div> */}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-lg-6 col-md-12 my-2">
                                                                                    <div className="session-box p-2 mt-3 border border-2 rounded" style={{ height: '100%' }}>
                                                                                        <p className="mb-1">Session Start Time</p>
                                                                                        <div className="d-flex justify-content-between align-items-center me-0">

                                                                                            {/* <div className="col-lg-10 col-md-10"> */}
                                                                                            <h6 className="mb-0 small">{item?.time_slot?.formated_start_end_time} ({item?.time_slot?.timeZoneAbb})</h6>
                                                                                            {/* </div>
                                                                                            <div className="col-lg-2 col-md-2"> */}
                                                                                            <i className="bi bi-clock-fill" />
                                                                                            {/* </div> */}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-lg-12 my-3">
                                                                                <div className="session-box p-2 mt-3 border border-2 rounded">
                                                                                    <p className="mb-1">Topic Details</p>
                                                                                    <h6 className="mb-0">{item?.topic_details}</h6>
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    ))}
                                                                    <div className="col-lg-12 my-3">
                                                                        <Link to="/tutor/update-batch" state={data} className="btn btn-primary mb-4 mt-2">Edit</Link>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                                :
                                                <div className='no-data-img'>
                                                    <img width={100} src="/assets/img/user/no-data.png" alt="" srcset="" />

                                                </div>}


                                            {pageCount > 1 && (
                                                <ResponsivePagination
                                                    pageCount={pageCount}
                                                    currentPage={currentPage}
                                                    handlePageClick={handlePageClick}
                                                />
                                            )}
                                        </div>
                                    }
                                </div>
                            </main>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default TutorCourseBatchList